import { render, staticRenderFns } from "./PackageManagementView.vue?vue&type=template&id=11a7b388&scoped=true"
import script from "./PackageManagementView.vue?vue&type=script&lang=js"
export * from "./PackageManagementView.vue?vue&type=script&lang=js"
import style0 from "./PackageManagementView.vue?vue&type=style&index=0&id=11a7b388&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a7b388",
  null
  
)

export default component.exports